import React from "react";

export default function ({
  title,
  children,
  classes = "",
  bodyClasses = "",
}) {
  return (
    <div className={`card${classes ? " " + classes : ''}`}>
      <div className="card-header">
        <div className="card-title">
          <h2 className="color-dark-grey">{title}</h2>
        </div>
      </div>

      <div className={`${bodyClasses ? bodyClasses + " " : ''}card-body px-7 px-lg-15 pt-14 pb-7`}>
        {children}
      </div>
    </div>
  );
}